import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@assets/images/icons/pdf_primary.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, " The screen displays a record of payments you have made towards Plan C coverage ")
  ])
], -1)
const _hoisted_2 = { class: "contributions-tables cobra-payments" }
const _hoisted_3 = { class: "contributions-table-wrapper" }
const _hoisted_4 = { class: "contributions-table-item no-striped" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Statement Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Coverage Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Receipt Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Check / Ref"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Source"),
    /*#__PURE__*/_createElementVNode("th", null, "View Statement")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString('-'), -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString('-'), -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "pdf"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, "No statements found.")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-center justify-content-md-end mt-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1),
          _createElementVNode("table", null, [
            _hoisted_5,
            ($setup.dataLoaded && $setup.cappDocuments.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cappDocuments, (document) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: document.DocumentID
                    }, [
                      _createElementVNode("td", null, _toDisplayString(document.StatementDate), 1),
                      _createElementVNode("td", null, _toDisplayString(document.CoveragePeriod), 1),
                      _createElementVNode("td", null, _toDisplayString(document.ReceiptDate), 1),
                      _hoisted_7,
                      (document.ShowCapp)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => ($setup.openModal(
                                            'hw-capp-payment-details',
                                            'CAPP Co-Payment History',
                                            'plan-c-mrp active',
                                            null,
                                            null,
                                            null,
                                            null,
                                            { From: document.CappFrom, To: document.CappTo }
                                            )), ["prevent"])
                            }, "View", 8, _hoisted_9)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_10,
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "javascript;",
                          onClick: _withModifiers(($event: any) => ($setup.openModal('smartsearch', null, 'modal-success', null, { DocumentID: document.DocumentID })), ["prevent"])
                        }, _hoisted_13, 8, _hoisted_11)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_14, _hoisted_16))
          ]),
          _hoisted_17
        ])
      ])
    ])
  ], 64))
}